/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NegotiationContractAttachmentsAliases {
  ACTION_DOWNLOAD = 'action-download',
  ACTION_REQUEST_CHANGE = 'action-request-change',
  AVATAR_0 = 'avatar-0',
  AVATAR_1 = 'avatar-1',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_ATTACHMENTS = 'deck-attachments',
  DECK_ATTACHMENTS_AMENDMENTS = 'deck-attachments-amendments',
  FETCH_ATTACHMENTS = 'fetch-attachments',
  FETCH_ATTACHMENTS_AMENDMENTS = 'fetch-attachments-amendments',
  FIELD_4 = 'field-4',
  FIELD_8 = 'field-8',
  FIELD_COUNTER_OFFER = 'field-counter-offer',
  FIELD_COUNTER_OFFER_AMENDMENTS = 'field-counter-offer-amendments',
  FIELD_MESSAGE_REQUEST_CHANGE = 'field-message-request-change',
  FORM_REQUEST_CHANGE = 'form-request-change',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  HPMS_CUSTOM_CARD_AMENDMENTS = 'hpms-custom-card-amendments',
  HPMS_TEXT_HTML_0 = 'hpms-text-html-0',
  HPMS_TEXT_HTML_1 = 'hpms-text-html-1',
  LEGENDS = 'legends',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  MODAL_REQUEST_CHANGE = 'modal-request-change',
  PANEL_AMENDMENTS = 'panel-amendments',
  PANEL_CONTRACT_ATTACHMENTS = 'panel-contract-attachments',
  PANEL_DRAFT = 'panel-draft',
  PANEL_REQUEST_CHANGE = 'panel-request-change',
  TEXT_AREA_REQUEST_CHANGE = 'text-area-request-change',
}
export { NegotiationContractAttachmentsAliases };
